module.exports = __webpack_public_path__ + "static/media/intro3.059704c2.png";